import { Listing } from '@kouto/cart-prices';
import { GetListingV3PublicResponse } from '@kouto/types';

const isV3Listings = (
  listings:
    | Record<string, Listing>
    | Record<string, GetListingV3PublicResponse>,
): listings is Record<string, GetListingV3PublicResponse> => {
  const firstListing = Object.values(listings)[0];
  // V3 has resourceGroups as an array, V1 has it differently
  return (
    firstListing &&
    'resourceGroups' in firstListing &&
    Array.isArray(firstListing.resourceGroups)
  );
};

export default isV3Listings;
